import { Link } from "@tanstack/react-router";
import { BrandLockup } from "./BrandMark";
import { ViewerMenu } from "./ViewerMenu";

/**
 * The phone's entire chrome, and the reason the top bar was not simply
 * deleted (backlog item 13).
 *
 * The sidebar is `hidden … md:flex` — below 768px it is `display: none`, so
 * the bar that item 13 asks to remove is not three controls beside a logo
 * down there, it is *everything*: the brand, the theme control and Lock.
 * Removing it as written would have left a phone with none of them, on top of
 * the navigation it already does not have.
 *
 * So the bar keeps a life below `md` and loses it everywhere else, carrying
 * the same `ViewerMenu` the sidebar footer carries rather than a second copy
 * of the three controls. Giving the sidebar a real mobile drawer is the right
 * end state and is a larger piece of work than this item describes; until it
 * exists this is the honest floor rather than a regression dressed as a
 * cleanup.
 */
export function MobileHeader() {
  return (
    <header className="border-border bg-bg flex h-14 shrink-0 items-center gap-3 border-b px-4 md:hidden">
      {/* The only navigation a phone has, so the mark is a link to home. */}
      <Link to="/" className="rounded-element min-w-0">
        <BrandLockup size={26} />
      </Link>
      <div className="flex-1" />
      <ViewerMenu />
    </header>
  );
}
